module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/264.4edcc05c.png";